import ApiResource from "../../../Lib/ApiResource";

export default class UsersResource extends ApiResource {

    index() {
        return this.get('users');
    }

    show(id) {
        return this.get('users/'+id);
    }

    update(id, data) {
        return this.patch('users/'+id, data);
    }

}